// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { bomTableProductChildStyles } from "@stoneage/App/Components/ProductDetails/BomTableProductChild";
import { fontConfig } from "@stoneage/XDL/constants";
import { color, nestedTableRowCss } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

bomTableProductChildStyles.bomTableProductCard = {
    row: {
        css: css`
            &&& {
                background: ${color("common.ui3")};
            }
            &:not(:last-child) {
                border: none;
            }
            ${nestedTableRowCss}
        `,
    },
    partNumberCellStyle: {
        css: css`
            a ${TypographyStyle} {
                font-weight: ${fontConfig.weight.regular};
            }
        `,
    },
};
